import { SimpleGrid, Stack } from '@mantine/core';
import { RevisionGetResponse as Revision } from 'api/actions/revision-get/revision-get-response';
import H3Medium from 'components/typography/H3Medium';
import P1Medium from 'components/typography/P1Medium';
import P2Regular from 'components/typography/P2Regular';
import ReadonlyText from 'components/typography/ReadonlyText';
import { useMemo } from 'react';
import { useResponsiveDesign } from 'hooks/use-responsive-design';

/**
 * Displays the changes of revision plans made when the revision has been completed.
 */
export default function RevisionPlanChangeLog({ revision }: { revision: Revision }) {
  const { isMobile, isTablet } = useResponsiveDesign();
  const gridStyle = useMemo(
    () => ({
      borderBottom: '1px solid var(--mantine-color-gray-1)',
      alignItems: 'flex-start',
    }),
    []
  );

  if (!revision.revisionPlanChangeLogs || revision.revisionPlanChangeLogs.length === 0) {
    return null;
  }

  return (
    <Stack pt={24} pb={40} px={isTablet ? 20 : 40} bg="white" style={{ borderRadius: '4px' }} spacing={24}>
      <H3Medium color="gray.7">Zmeny termínov zariadení</H3Medium>
      {isMobile ? (
        <Stack spacing={0}>
          {revision.revisionPlanChangeLogs.map((log) => (
            <Stack
              key={log.revisionPlanChangeLogId}
              spacing={12}
              py={16}
              px={16}
              sx={(theme) => ({ borderBottom: `1px solid ${theme.colors.gray[1]}` })}
            >
              <ReadonlyText title="Termín" value={log.typeBefore} />
              <ReadonlyText title="Pôvodný dátum" value={log.nextRevisionBefore ?? '-'} />
              <ReadonlyText
                title="Pôvodná perióda"
                value={log.periodBefore === undefined ? '-' : String(log.periodBefore)}
              />
              <ReadonlyText title="Nový dátum" value={log.nextRevisionAfter ?? '-'} />
              <ReadonlyText
                title="Nová perióda"
                value={log.periodAfter === undefined ? '-' : String(log.periodAfter)}
              />
            </Stack>
          ))}
        </Stack>
      ) : (
        <Stack spacing={0}>
          <SimpleGrid spacing={24} p={16} cols={5} bg="gray.0">
            <P1Medium>Termín</P1Medium>
            <P1Medium>Pôvodný dátum</P1Medium>
            <P1Medium>Pôvodná perióda</P1Medium>
            <P1Medium>Nový dátum</P1Medium>
            <P1Medium>Nová perióda</P1Medium>
          </SimpleGrid>
          {revision.revisionPlanChangeLogs.map((log) => {
            return (
              <SimpleGrid key={log.revisionPlanChangeLogId} spacing={24} py={24} px={16} style={gridStyle} cols={5}>
                <P2Regular>{log.typeBefore}</P2Regular>
                <P2Regular>{log.nextRevisionBefore}</P2Regular>
                <P2Regular>{log.periodBefore}</P2Regular>
                <P2Regular>{log.nextRevisionAfter}</P2Regular>
                <P2Regular>{log.periodAfter}</P2Regular>
              </SimpleGrid>
            );
          })}
        </Stack>
      )}
    </Stack>
  );
}
